import React, { useState } from 'react';
function Logo({
  src,
  alt,
  fallback,
  className = 'h-8 md:h-10 object-contain'
}: {
  src: string;
  alt: string;
  fallback: React.ReactNode;
  className?: string;
}) {
  const [error, setError] = useState(false);
  if (error) {
    return <div className="h-8 md:h-10 flex items-center justify-center" data-id="element-33" data-mp="1aeny5ljz1pza">
        {fallback}
      </div>;
  }
  return <img src={src} alt={alt} className={className} onError={() => setError(true)} data-id="element-34" data-mp="235fqg7xx1uhc" />;
}
export function CredibilityBar() {
  return <section className="w-full bg-white py-12 md:py-14 px-4 sm:px-6 lg:px-8 border-y border-gray-100 group" data-id="element-35" data-mp="275yjg5bjp6l4">
      <div className="max-w-7xl mx-auto text-center space-y-2" data-id="element-36" data-mp="1t92ybei0roop">
        {/* Group 1 */}
        <div data-id="element-37" data-mp="1y48legn5r9ed">
          <h2 className="text-xs font-medium uppercase tracking-tight text-brand-gray-light mb-3" data-id="element-38" data-mp="1y7wddbcyfnqz">
            20+ years leading teams at
          </h2>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 opacity-70 grayscale group-hover:grayscale-0 transition-all duration-300" data-id="element-39" data-mp="mrxw4k7mhveo">
            <Logo src="https://cdn.magicpatterns.com/uploads/v4PmSfCw4yML8qiYhuq31j/image.png" alt="T-Mobile" fallback={<span className="text-2xl font-bold tracking-tighter text-[#E20074]" data-id="element-41" data-mp="15joym27iwbys">
                  T-Mobile
                </span>} data-id="element-40" data-mp="rimcjpgj31nv" />
            <Logo src="https://cdn.magicpatterns.com/uploads/kzg4fyN3LtZMFnk1yoy3g7/image.png" alt="Qualcomm" className="h-6 md:h-8 object-contain" fallback={<span className="text-2xl font-semibold tracking-wide text-[#3253DC]" data-id="element-43" data-mp="1o7k839w3r3m3">
                  Qualcomm
                </span>} data-id="element-42" data-mp="1ei0kxs1cwnlf" />
            <Logo src="https://cdn.magicpatterns.com/uploads/j74EN6WpEgfq439Qbj4UQ6/image.png" alt="Sony" className="h-4 md:h-5 object-contain" fallback={<span className="text-3xl font-serif tracking-widest text-black" data-id="element-45" data-mp="20bxy9xpemj14">
                  SONY
                </span>} data-id="element-44" data-mp="1y6jhiuooz3a5" />
            <Logo src="https://cdn.magicpatterns.com/uploads/jmUZUe7ujmsVZ7FPQGXwBy/image.png" alt="HERE Technologies" className="h-14 md:h-16 object-contain" fallback={<span className="text-2xl font-black tracking-widest text-[#00AFAF]" data-id="element-47" data-mp="2jzovrfjxoiut">
                  HERE
                </span>} data-id="element-46" data-mp="257wozry7gd4p" />
          </div>
        </div>

        {/* Group 2 */}
        <div data-id="element-48" data-mp="2szk7blheifvd">
          <h2 className="text-xs font-medium uppercase tracking-tight text-brand-gray-light mb-1" data-id="element-49" data-mp="2t153tgna08vv">
            Adjunct Professor of Business Strategy
          </h2>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 opacity-70 grayscale group-hover:grayscale-0 transition-all duration-300" data-id="element-50" data-mp="ymcaxpds1w7m">
            <div className="h-14 md:h-16 overflow-hidden flex items-center justify-center" data-id="element-51" data-mp="13n00s7q9s709">
              <Logo src="https://cdn.magicpatterns.com/uploads/w94eKGq8sN5T6fAhM5Ldxm/image.png" alt="University of Washington" className="h-24 md:h-28 object-contain" fallback={<span className="text-2xl font-serif font-bold text-[#4B2E83]" data-id="element-53" data-mp="hd0ai1hpmtmv">
                    University of Washington
                  </span>} data-id="element-52" data-mp="w2pf66p0hfrw" />
            </div>
            <div className="h-14 md:h-16 overflow-hidden flex items-center justify-center" data-id="element-54" data-mp="1a0mevbyri2as">
              <Logo src="https://cdn.magicpatterns.com/uploads/rtK6kMqrmUgwB4d9TkfRxV/image.png" alt="Seattle University" className="h-24 md:h-28 object-contain" fallback={<span className="text-xl font-serif font-bold uppercase tracking-wider text-[#AA0000]" data-id="element-56" data-mp="3pt3adl2kze0n">
                    Seattle University
                  </span>} data-id="element-55" data-mp="151t1djjh6bam" />
            </div>
          </div>
        </div>

        {/* Group 3 */}
        <div data-id="element-57" data-mp="1i8ywb8f7259h">
          <h2 className="text-xs font-medium uppercase tracking-tight text-brand-gray-light mb-3" data-id="element-58" data-mp="1i9s3ublz8yso">
            Trusted by teams at
          </h2>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 opacity-70 grayscale group-hover:grayscale-0 transition-all duration-300" data-id="element-59" data-mp="13hzs09le62vp">
            <Logo src="https://cdn.magicpatterns.com/uploads/3APyYKvhRHDFEwKJoXnrxg/image.png" alt="Motorola Solutions" className="h-8 md:h-10 object-contain" fallback={<span className="text-2xl font-bold text-black" data-id="element-61" data-mp="1mceptvvyvphy">Motorola</span>} data-id="element-60" data-mp="1w9t69vhw4ea9" />
            <Logo src="https://cdn.magicpatterns.com/uploads/diyFRn9ySMDaoZwXUKcrWG/HTEC_Logotype_black-1.png" alt="HTEC Group" className="h-6 md:h-8 object-contain" fallback={<span className="text-2xl font-black tracking-widest text-black" data-id="element-63" data-mp="2u17z3cka6l78">
                  HTEC
                </span>} data-id="element-62" data-mp="1rb859tutdqkr" />
            <Logo src="https://cdn.magicpatterns.com/uploads/qt8nWDJv3BJa647m1LENZT/image.png" alt="Snøhetta" className="h-5 md:h-6 object-contain" fallback={<span className="text-2xl font-semibold text-black" data-id="element-65" data-mp="2bbj8fvngpqxo">
                  Snøhetta
                </span>} data-id="element-64" data-mp="2p50q1awl8tl2" />
            <Logo src="https://cdn.magicpatterns.com/uploads/wMSzDe9m91AxMaFhvMiNG1/image.png" alt="Mithun" className="h-5 md:h-6 object-contain" fallback={<span className="text-2xl font-semibold text-black" data-id="element-67" data-mp="2fbjua1cw54er">
                  Mithun
                </span>} data-id="element-66" data-mp="26dq1v1i8yuwv" />
          </div>
        </div>
      </div>
    </section>;
}